import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { Region } from './regions.service';
import { sectorslist } from './sectors.service';
import { CustomerDTO } from 'src/app/components/pages/customer-orders/customerdto';

export class Customer{

  public customerId : number;
  public customerName : String;
  public customerNumber : String;
  public email : String;
  public customerGroupName : String;

  public mobileNumber : String;
  public contactPersonName : string;
  public sector : sectorslist;
  public region: Region;

  constructor(){

    let sectorObj = new sectorslist();
    let sectorId = -1;
    let sector="";
    sectorObj.sector=sector;
    sectorObj.sectorId=sectorId;

    this.sector = sectorObj;

    let regionObj = new Region();
    regionObj.regionId=-1;
    regionObj.region="";
    this.region = regionObj;
  }
}

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  
  constructor(private httpClient:HttpClient) { }

  public retriveCustomersByRegionAndSector( details : any) {
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.post<Customer[]>('/api/v1/customer/regsec/', details , {headers}).pipe(catchError(this.errorHandler));
  }

  public retrieveAllCustomers(): Observable<Customer[]> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.get<Customer[]>('/api/v1/customer/?pageNumber=-1', { headers })
  }  
  
      // return this.httpClient.get<Customer[]>('/api/v1/customer/?pageNumber=-1' , {headers})
      // .pipe(catchError(this.errorHandler)); 
  deleteCustomer(customerId : any) {
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.delete('/api/v1/customer/' + customerId , {headers})
    .pipe(catchError(this.errorHandler)); 
  }
  
  
  createCustomer(customerDTO : Customer): Observable<any>{

    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.post<any>('/api/v1/customer/' , customerDTO , {headers})
    .pipe(catchError(this.errorHandler)); 

  }

  updateUser(userDTO : Customer) : Observable<any>{
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.put<any>('/api/v1/customer/', userDTO , {headers}).pipe(catchError(this.errorHandler));
  }

  public retrieveCustomersWithStockItems(): Observable<CustomerDTO[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.get<CustomerDTO[]>('/appliances/api/v2/customers/with-stock-items', { headers })
      .pipe(catchError(this.errorHandler));
  }


  public errorHandler(error: HttpErrorResponse){
    console.log(error.message);
    return throwError(error.message || 'Server Error');

  }
}
